import { HaNContext, useRoomsModel } from "@lib/logic";
import { getShouldShowHereAndNowConnectYourCalendarFullScreen, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { FloorSuggestions } from "../shared/FloorSuggestions/FloorSuggestions";
import { HaNCalendarConsent } from "../shared/HaNCalendarConsent";
import { SelectedFloorHeader } from "../shared/SelectedFloorHeader";
import { RoomsOnFloor } from "./components/RoomsOnFloor";
import { RoomCell } from "./RoomCell";

export const RoomsList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "rooms") return null;

  return <RoomsListContent />;
};

// Without a calendar there are no rooms to list, only the request to connect one
const RoomsListContent = () => {
  const isAskingForCalendar = useAppSelector(getShouldShowHereAndNowConnectYourCalendarFullScreen);
  const { suggestions } = useRoomsModel();

  if (isAskingForCalendar) {
    return (
      <div className="flex flex-1 items-center justify-center p-5">
        <HaNCalendarConsent />
      </div>
    );
  }

  return (
    <>
      <SelectedFloorHeader />

      <RoomsOnFloor />

      <FloorSuggestions
        kind="room"
        suggestions={suggestions}
        renderCell={room => <RoomCell room={room} />}
      />
    </>
  );
};
